"use strict";
// ============================================================================
// Menstrual Cycle Constants
// ============================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.CYCLE_CATEGORY_TO_DAYS = void 0;
/**
 * Cycle Length Category to Days Mapping
 *
 * Maps cycle length categories to representative day counts.
 * Used for cycle date advancement calculations.
 */
exports.CYCLE_CATEGORY_TO_DAYS = {
    short: 23, // 21-25 days
    average: 28, // 26-30 days
    long: 33, // 31+ days
};
//# sourceMappingURL=constants.js.map